<template>
    <div class="loader-page" :class="gifPosition">
        <div class="loader-container">
            <img src="@/assets/icons/pacman.gif" alt="">
            <p v-if="loaderText">{{ loaderText }}</p> 
            <p v-else>Uploading files and data</p>
        </div>
    </div>
</template>
<script setup lang="ts">
  import { defineProps } from 'vue';
  const props = defineProps(['loaderText', 'gifPosition'])
</script>
<style lang="scss" scoped>
.loader-page {
    position: fixed;
    width: 100%;
    height: 100vh;
    background: transparent;
    top: 0;
    left: 0;
    z-index: 1000;
    display: flex;
    justify-content: center;
    backdrop-filter: blur(1px);
    background-color: rgb(221 221 221 / 50%);
    &.center {
      align-items: center;
    } 
    &.bottom {
      align-items: end;
    }
}
.loader-container {
    display: flex;
    align-items: center;
    padding-bottom: 2rem;
    p {
        font-family: $secondary-font;
        font-size: 1.5rem;
        color: #3c6574;
    }
    img {
      max-width: 70px;
    }
}
</style>